import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-table-sortable', 'sortBy', 'Kārtot pēc');
Labels.set('ui-table-sortable', 'clickToSort', 'Noklikšķini, lai kārtotu');
